import React from "react";
import {Bar} from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip as ChartTooltip,
  Legend as ChartLegend,
  ChartOptions,
  ChartData
} from "chart.js";
import "chartjs-adapter-date-fns";

import {chartHeight} from "../../constants";
import colors from "../../styles/colors";
import {useChartTheme} from "../../contexts/ChartThemeContext";
import {ChartErrorBoundary} from "../Charts/ChartErrorBoundary";

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, ChartTooltip, ChartLegend);

interface AntRxFailuresEmptyReportProps {
  axisSeries?: any;
}

const AntRxFailuresEmptyReport: React.FC<AntRxFailuresEmptyReportProps> = () => {
  const {getThemeColors} = useChartTheme();
  const themeColors = getThemeColors();

  // Create empty data for visualization
  const emptyData = Array.from({length: 10}, (_, i) => ({
    time: `T${i + 1}`,
    rxfail: 0
  }));

  const legend = [
    {
      key: "rxfail",
      label: "RxFail"
    }
  ];

  // Chart.js data configuration
  const data: ChartData<"bar", number[], string> = {
    labels: emptyData.map((d) => d.time),
    datasets: [
      {
        label: "RxFail",
        data: emptyData.map((d) => d.rxfail),
        backgroundColor: colors.sonicblue + "4D", // 30% opacity
        borderColor: colors.sonicblue,
        borderWidth: 1,
        borderRadius: 4
      }
    ]
  };

  // Chart.js options configuration
  const options: ChartOptions<"bar"> = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: false // No tooltips for empty chart
      }
    },
    scales: {
      x: {
        type: "category",
        display: true,
        grid: {
          display: true,
          color: themeColors.grid + "30",
          drawOnChartArea: true,
          drawTicks: true
        },
        ticks: {
          color: themeColors.text,
          font: {
            size: 11
          }
        }
      },
      y: {
        type: "linear",
        display: true,
        position: "left",
        title: {
          display: true,
          text: "RxFail",
          color: themeColors.text
        },
        grid: {
          display: true,
          color: themeColors.grid + "30",
          drawOnChartArea: true,
          drawTicks: true
        },
        ticks: {
          color: themeColors.text,
          font: {
            size: 11
          }
        },
        min: 0,
        max: 5
      }
    }
  };

  return (
    <ChartErrorBoundary>
      <div>
        <h5>ANT+ RX Failures</h5>

        <div style={{marginBottom: "10px"}}>
          <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
            <div
              style={{
                width: "12px",
                height: "12px",
                backgroundColor: colors.sonicblue,
                borderRadius: "2px"
              }}
            ></div>
            <span style={{color: themeColors.text}}>{legend[0].label}</span>
          </div>
        </div>

        <div style={{width: "100%", height: chartHeight, position: "relative"}}>
          <Bar data={data} options={options} />
        </div>
      </div>
    </ChartErrorBoundary>
  );
};

export default AntRxFailuresEmptyReport;
